import React, { FC, useEffect } from "react";

import MultiValueTextFieldGroup from "../../../components/MultiValueTextFieldGroup";
import TextField from "../../../components/styled/TextField";

type PPLValueProps = {
  readonly: boolean;
  operator: string;
  value: any;
  onChange: (value: any) => void;
};

const PPLStringValue: FC<PPLValueProps> = ({ readonly, value, onChange }) => {
  // convert the value to a string
  useEffect(() => {
    if (typeof value !== "string") {
      onChange(`${value}`);
    }
  }, [value]);

  return (
    <TextField
      label={"Value"}
      fullWidth
      value={value}
      onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
        onChange(evt.target.value);
      }}
      disabled={readonly}
    />
  );
};

const PPLStringListValue: FC<PPLValueProps> = ({
  readonly,
  value,
  onChange,
}) => {
  // convert the value to an array
  useEffect(() => {
    if (!Array.isArray(value)) {
      onChange([`${value}`]);
    }
  }, [value]);

  return Array.isArray(value) ? (
    <MultiValueTextFieldGroup
      values={value}
      onSave={(values) => {
        onChange(values);
      }}
      disabled={readonly}
    />
  ) : (
    <></>
  );
};

const PPLValue: FC<PPLValueProps> = ({
  readonly,
  operator,
  value,
  onChange,
}) => {
  return ["in", "not_in"].includes(operator) ? (
    <PPLStringListValue
      readonly={readonly}
      operator={operator}
      value={value}
      onChange={onChange}
    />
  ) : (
    <PPLStringValue
      readonly={readonly}
      operator={operator}
      value={value}
      onChange={onChange}
    />
  );
};
export default PPLValue;
